// reactRouterNoindexLoader.js
import { createInitialStoreWithRequest } from '../createInitialStore.js';
import getMetaTagsForHelmet from './getMetaTagsForHelmet.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import { BRANDING_NAME } from '../RemoteConfigKeys.js';
import { TranslationNamespace } from './translationNamespace.js';

const DEFAULT_HOSTNAME = 'swag.live';
const DEFAULT_BRANDING_NAME = 'SWAG';
const SEO_HOME_TITLE_KEY = 'seo-home-title';

/**
 * React Router loader that returns meta tags with noindex, nofollow robots directive
 * This is useful for pages that should not be indexed by search engines (e.g., chat pages)
 * @param {Object} params - React Router params
 * @param {Object} request - React Router request
 * @param {Object} i18nInstance - i18n instance from withI18nLoader (required)
 * @returns {Promise<Object>} Loader data with meta tags and staticContext
 */
export const reactRouterNoindexLoader = async ({
  params,
  request,
  i18nInstance,
}) => {
  const { store } = await createInitialStoreWithRequest({ params, request });
  const state = store.getState();

  const brandingName =
    getRemoteConfigData(state, BRANDING_NAME) || DEFAULT_BRANDING_NAME;
  const hostname = request?.headers?.get('host') || DEFAULT_HOSTNAME;

  // Use default site title from translation, fallback to brandingName
  let defaultTitle = brandingName;
  if (
    i18nInstance &&
    i18nInstance.customExists(SEO_HOME_TITLE_KEY, {
      ns: TranslationNamespace.SEO,
    })
  ) {
    defaultTitle = i18nInstance.t(SEO_HOME_TITLE_KEY, {
      ns: TranslationNamespace.SEO,
    });
  }

  // Pages should not be indexed by search engines
  // Following Next.js pattern: use noindex, nofollow
  const meta = getMetaTagsForHelmet({
    title: defaultTitle,
    siteName: brandingName,
    hostname,
    robots: ['noindex', 'nofollow'],
  });

  return {
    meta,
    staticContext: {
      requestHeaders: {
        hostname,
      },
    },
  };
};

export default reactRouterNoindexLoader;
